import {InsertQna} from "../qna/api/qnApi.js";
import * as UIUtil from "/app/js/util/UI.js";
import * as _UIUtil from "../util/UI.js";


let fileArray = [];
let noticeId;

export const open = async function (menuKey, key) {
    try {
        const lang = document.documentElement.lang;
        const tabMap = {
            Information_Privacy: "tab01",
            Information_LBS: "tab02",
            Information_Email: "tab03",
            Information_Contact: "tab04"
        };

        const tabClass = tabMap[key];
        if (!tabClass) {
            // console.log("Invalid tab key:", key);
            return;
        }


        const htmlUrl = `app/html/${lang}/main/${menuKey}.html?tab=${tabClass}`;


        try {
            const response = await fetch(htmlUrl);
            const text = await response.text();
            const headerWrap = document.querySelector(".headerWrap");
            const contentWrap = document.querySelector(".contents-wrap, .contentWrap, .contentsWrap");
            if (contentWrap) {
                contentWrap.remove();
            }
            await headerWrap.insertAdjacentHTML('afterend', text);
            initEvt();
            commonTab('tabArea', tabClass);
        } catch (error) {
            console.error('HTML 로딩 중 오류 발생:', error);
            throw error; // 오류를 다시 던져서 호출하는 쪽에서 처리하도록 함
        }
    } catch (err) {
        console.error("Error in Information.open():", err);
    }
}


function initEvt() {
    const _formEl = document.querySelector("form.ask.form");
    const askBtn = _formEl.querySelector(".ask-btn-wrap button");


    //add msgbox!!!
    const regexName = /^.{0,20}$/; // Max 20 characters for Name
    const regexTitle = /^.{0,255}$/; // Max 255 characters for Title
    const regexContent = /^.{0,300}$/;


    const getPhoneNumber = () => {
        const hp1 = _formEl.querySelector('select[name="hp1"]').value;
        const hp2 = _formEl.querySelector('input[name="hp2"]').value;
        const hp3 = _formEl.querySelector('input[name="hp3"]').value;

        return `${hp1}-${hp2}-${hp3}`;
    };

    const getEmail = () => {
        const email1 = _formEl.querySelector('input[name="email1"]').value.trim();
        const email2 = _formEl.querySelector('input[name="email2"]').value.trim();
        const mailSelect = _formEl.querySelector('.select2');

        // if (!mailSelect) {
        //     console.error("Select элемент с классом 'select2' не найден");
        //     return null;
        // }

        let emailDomain = mailSelect.options[mailSelect.selectedIndex].value;


        if (emailDomain === '') {
            emailDomain = email2;
        }

        const email1RegExp = /^[a-zA-Z0-9._%+-]+$/;
        const email2RegExp = /^([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;

        if (!email1RegExp.test(email1)) {
            const msg = document.documentElement.lang === 'en'
                ? "Invalid format for the email prefix."
                : "이메일 앞부분 형식이 잘못되었습니다.";
            UIUtil.msgBox(msg, "warning");
            return null;
        }

        if (email2 && !email2RegExp.test(email2)) {
            const msg = document.documentElement.lang === 'en'
                ? "Invalid email domain format."
                : "도메인 형식이 잘못되었습니다.";
            UIUtil.msgBox(msg, "warning");
            return null;
        }


        // Вернуть корректный email
        if (email1 && emailDomain) {
            return `${email1}@${emailDomain}`;
        } else {
            return null;
        }
    };

    const formData = new FormData();
    const fileInput = document.querySelector('#ex_filename_2');

    fileInput.addEventListener('change', () => {
        const selectedFiles = Array.from(fileInput.files);

        if (fileArray.length + selectedFiles.length > 3) {
            const msg = document.documentElement.lang === 'en'
                ? "You can attach up to 3 files (JPG, PNG, PPT only, max total size 30MB). Please check the number of files again."
                : "최대 3개까지 30MB, JPG,PNG,PPT 파일만 첨부 가능합니다. 파일 개수를 다시 한번 확인해 주십시오.";
            alert(msg);
            return;
        }

        selectedFiles.forEach(file => {
            if (fileArray.length < 3) {
                fileArray.push(file);
                // console.log("선택 파일", file.name);
            } else {
                // console.log("최대 파일 개수 (3).");
            }
        });


    });

    askBtn.addEventListener('click', async function () {

            const agreeChk = _formEl.querySelector('#tmp-5');
            if (!agreeChk || !agreeChk.checked) {
                const msg = document.documentElement.lang === 'en'
                    ? "You must agree to the collection and use of personal information to submit an inquiry."
                    : "개인정보 수집 및 이용에 동의하셔야 문의를 등록할 수 있습니다.";
                UIUtil.msgBox(msg, "warning");
                return;
            }
            // const regNm = name.value.replace(/\s+/g, ''); // Corrected here
            const regNm = _formEl.querySelector('input[name="name"]').value;
            const regTel = getPhoneNumber();
            const regMail = getEmail();
            if (regMail === null) {
                return;
            }

            const questionTitl = _formEl.querySelector('input[name="title"]').value;
            const questionCont = _formEl.querySelector('textarea[name="cont"]').value;

            const param = {
                "regNm": regNm,
                "regTel": regTel,
                "regMail": regMail,
                "title": questionTitl,
                "content": questionCont,
            };


            formData.append("data", new Blob([JSON.stringify(param)], {type: "application/json"}));


            fileArray.forEach(file => {
                formData.append("files", file);
            });

            try {
                const response = await InsertQna(formData);

                if (response && response.SUCCESS) {
                    const msg = document.documentElement.lang === 'en'
                        ? "Inquiry submitted successfully."
                        : "문의가 정상적으로 등록되었습니다.";
                    UIUtil.msgBox(msg, "success");

                    _formEl.reset();

                    fileArray.length = 0;
                    const uploadNameEl = document.querySelector(".upload-name");
                    if (uploadNameEl) {
                        uploadNameEl.innerHTML = "";
                    }

                    const email2 = _formEl.querySelector('input[name="email2"]');
                    if (email2) email2.value = "";

                    const selectEl = _formEl.querySelector(".select2");
                    if (selectEl) selectEl.selectedIndex = 0;

                    commonTab("tabArea", "tab04");

                    return response;
                } else {
                    console.error("Failed to insert data:", response);
                    return null;
                }
            } catch (error) {
                console.error("Error during API request:", error);
                return null;
            }

        }
    );

    function checkDomain() {

    }
}
